<template>
  <section class="heim-site-card">
    <aside class="status-color" :class="true?'red':'green'"></aside>
    <section class="content">
      <header>
        <span class="label">{{site.name}}</span>
        <div class="link"><a
            :href="site.url"
            target="_blank"
          >{{site.url}}</a></div>
      </header>
      <footer>
        <router-link class="paper-action" :to="{ path: `/sites/${site.id}/details` }"><heim-icon class="icon" icon="timeline"></heim-icon><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
      </footer>
    </section>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon";

export default {
  name: "heim-status-card",
  components: {
    HeimIcon
  },
  props: {
    site: {
      type: Object
    }
  }
};
</script>

<style scoped>
.heim-site-card {
  margin-right: 1em;
  margin-bottom: 1em;
  flex-grow: 1;
  min-width: 18em;
  max-width: 18em;
  display: flex;
  word-break: break-word;
  border-radius: 8px;
  background: var(--heim-white-color);
  box-shadow: var(--heim-shadow);
  overflow: hidden;
  position: relative;
}

.heim-site-card .content {
  flex: 1;
}

.heim-site-card header {
  padding: 0.8rem;
  margin-bottom: 3em;
}

.heim-site-card header .label,
.heim-site-card header .link {
  display: block;
  min-height: 2em;
}

.heim-site-card footer {
  background-color: var(--heim-grey-color);
  padding: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  bottom: 0;
}

.status-color {
  width: 1em;
  min-width: 1em;
  background-color: green;
  transition: background-color 0.3s ease;
}
.warn .status-color {
  background-color: orange;
}
.issue .status-color {
  background-color: #f84242;
}
</style>
